function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "7px",
  height: "7px",
  viewBox: "0 0 10 7"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fillOpacity: 1
  },
  d: "M 1.121094 0.972656 C 1.121094 0.878906 1.152344 0.792969 1.199219 0.707031 C 1.316406 0.511719 1.554688 0.390625 1.816406 0.390625 L 8.761719 0.390625 C 9.019531 0.390625 9.261719 0.511719 9.378906 0.707031 C 9.5 0.898438 9.476562 1.132812 9.324219 1.3125 L 6.082031 5.394531 C 5.949219 5.546875 5.742188 5.640625 5.519531 5.640625 C 5.296875 5.640625 5.082031 5.546875 4.957031 5.394531 L 1.253906 1.3125 C 1.171875 1.214844 1.121094 1.089844 1.121094 0.972656 Z M 1.121094 0.972656 "
})));
export default SvgIconDropdown;